



















































































import {
    defineComponent,
    computed,
    PropType,
    ref,
    useContext,
} from "@nuxtjs/composition-api";
import CtaHeading from "components/theme/Content/CtaHeading.vue";
import { useImage } from "@wemade-vsf/composables";
import { SfButton } from "@storefront-ui/vue";

interface CarouselImage {
    image: string;
    caption: string;
    link: string;
}

export default defineComponent({
    name: "ItemGrid",
    props: {
        items: {
            type: Array as PropType<Array<CarouselImage>>,
            default: () => [],
        },
        title: {
            type: String,
            default: "",
        },
        link: {
            type: String,
            default: "",
        },
        linkText: {
            type: String,
            default: "",
        },
    },
    data() {
        return {};
    },
    components: {
        CtaHeading,
        SfButton,
    },
    setup(props) {
        const { app } = useContext();
        const { getMagentoImage } = useImage();
        const transformedItems = computed(() => {
           const items = props.items.map((i) => {
                const item = { ...i };
                if (!item.image) {
                    item.image = null;
                    return item;
                }
                if (item.image.startsWith("http")) {
                    return item;
                }
                let imgPath = item.image.startsWith("/") ? item.image : "/" + item.image;
                if (!imgPath.startsWith("/media")) {
                    imgPath = "/media" + imgPath;
                }
                imgPath = imgPath.replace(/(\/media)+/g, "/media");
                item.image = getMagentoImage(imgPath);
                return item;
            });

            if (!isMobile.value) {
                return items;
            } else {
                return showMore.value ? items : items.slice(0, 5);
            }
        });

        const showMore = ref(false);
        const hasMore = computed(() => props.items.length > 5);
        const isMobile = computed(() => app.$device.isMobile);

        return {
            transformedItems,
            hasMore,
            showMore,
            isMobile,
        };
    },
});
